import { ChatConfirm } from '../chat-sheet.service';

/** One patient a run under a patient heading was filed to: how many messages, and whether filing to them goes on. */
export interface RunPatient {
  name: string;
  count: number;
  filing: boolean;
}

const messages = (n: number) => (n === 1 ? '1 message' : `${n} messages`);

function nameList(names: string[]): string {
  return names.length === 1 ? names[0] : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}

/**
 * The question before unlinking every message under a patient heading. One patient: confirm. Several: tick the
 * patients to unlink (`choices`, in the order given).
 */
export function unlinkRunQuestion(patients: RunPatient[]): ChatConfirm {
  if (patients.length === 1) {
    const { name, count, filing } = patients[0];
    const taken = count === 1
      ? `The message under this heading is taken off ${name}'s record. The record keeps a note that it was unlinked.`
      : `All ${count} messages under this heading are taken off ${name}'s record. The record keeps a note that they were unlinked.`;
    return {
      title: `Unlink from ${name}?`,
      message: taken + (filing ? ` Filing this conversation to ${name} stops too.` : ''),
      confirmText: count === 1 ? 'Unlink' : `Unlink all ${count}`,
      danger: true,
    };
  }
  return {
    title: 'Unlink which patients?',
    message: 'Pick the patients whose record these messages come off. The record keeps a note that they were unlinked.',
    confirmText: 'Unlink',
    danger: true,
    choices: patients.map((p) => `${p.name} · ${messages(p.count)}`),
  };
}

/** The snack once done: "3 messages unlinked from A and B". */
export function unlinkRunDone(unlinked: number, names: string[]): string {
  return `${messages(unlinked)} unlinked from ${nameList(names)}`;
}
